import styled from "styled-components";

export const Centre = styled.div`
  display: grid;
  place-items: center;
  margin: 4rem 0;
`